// extracted by mini-css-extract-plugin
export default {"mapPanel":"MapMobile_mapPanel__HaMRr","map":"MapMobile_map__W+it1"};